//App
import { LookupGroupApiType } from "./types/apiTypes";
import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";

const lookupGroupApi: LookupGroupApiType = {
  get: (value) => apiClient.get(endPoints.lookupGroup.get(value)),
  getAllByLookupTypeId: (payload) =>
    apiClient.get(endPoints.lookupGroup.getAllByLookupTypeId(), payload),
  getLookupGroupsView: (payload) =>
    apiClient.get(endPoints.lookupGroup.getLookupGroupsView(), payload),
  searchLookupGroups: (payload) =>
    apiClient.post(endPoints.lookupGroup.searchLookupGroups(), payload),
  save: (payload) => apiClient.post(endPoints.lookupGroup.save(), payload),
  delete: (value) => apiClient.delete(endPoints.lookupGroup.delete(value)),
  activate: (value) => apiClient.post(endPoints.lookupGroup.activate(value)),
};

export default lookupGroupApi;
